import { Routes } from '@angular/router';
import { CookieSettingsGuard } from '@teamfoster/sdk/cookie-ngrx';
import { DictionaryGuard } from '@teamfoster/sdk/dictionary-signals';
import { MenuGuard } from '@teamfoster/sdk/menu-signals';

import { SocialChannelsGuard } from './social-media/guards';

const appGuards = [CookieSettingsGuard, DictionaryGuard, MenuGuard, SocialChannelsGuard];

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layouts/website-layout/website-layout.component').then(m => m.WebsiteLayoutComponent),
    pathMatch: 'prefix',
    canActivate: [...appGuards],
    children: [
      {
        path: 'kerstgroet',
        loadChildren: () => import('./christmas/christmas.routes').then(m => m.routes),
      },
      {
        path: 'styleguide',
        loadChildren: () => import('./styleguide/styleguide.routes').then(m => m.routes),
      },
      {
        path: 'contentblokken',
        pathMatch: 'prefix',
        loadChildren: () => import('./content-blocks/content-blocks.routes').then(m => m.routes),
      },
      {
        path: 'pagina',
        pathMatch: 'prefix',
        loadChildren: () => import('./content/content.routes').then(m => m.routes),
      },
      {
        path: 'cases',
        pathMatch: 'prefix',
        loadChildren: () => import('./cases/cases.routes').then(m => m.routes),
      },
      {
        path: 'verdieping',
        pathMatch: 'prefix',
        loadChildren: () => import('./articles/articles.routes').then(m => m.routes),
      },
      {
        path: 'speelplaats',
        loadChildren: () => import('./playground/playground.routes').then(m => m.routes),
      },
      {
        path: 'linktree',
        loadChildren: () => import('./linktree/linktree.routes').then(m => m.routes),
      },
      {
        path: '404',
        loadComponent: () => import('./404.component').then(m => m.NotFoundComponent),
      },
      {
        path: '',
        pathMatch: 'prefix',
        loadChildren: () => import('./landing-pages/landing-pages.routes').then(m => m.routes),
      },
      {
        path: '**',
        redirectTo: '/404',
      },
    ],
  },
];
